export default __webpack_public_path__ + "static/media/workouttimes_7@3x.23897fb4.jpg";